import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.section`
  max-width: 136.3rem;
  padding: 2.4rem;
  overflow-y: auto;

  /* &::-webkit-scrollbar {
    display: none;
  } */

  margin: 0 21% 0 0;
  background: #fff;
  border-radius: 0.6rem;

  @media (max-width: ${breakpoints.medium}) {
    margin: 1.6rem auto;
    width: 90%;
  }
`;

export const Title = styled.h2`
  font-size: 2.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.medium}) {
    text-align: center;
  }
`;

export const Header = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const InfosContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  row-gap: 3.2rem;
  column-gap: 6.4rem;

  @media (max-width: ${breakpoints.medium}) {
    grid-template-columns: 1fr;
  }
`;

export const InfosItem = styled.div`
  font-size: 1.4rem;
`;

export const InfosItemExpanded = styled.div`
  grid-column: 1 / -1;
  font-size: 1.4rem;

  p {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 10px;
  }
`;

export const InfosItemTitle = styled.h3`
  margin-bottom: 1.6rem;
  white-space: nowrap;
`;

export const InfosItemValue = styled.p``;

export const Divider = styled.div`
  grid-column: 1 / -1;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.3);
`;

export const Footer = styled.section`
  display: flex;
  justify-content: flex-start;
  margin-top: 2.4rem;
  gap: 1.6rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    align-items: center;
  }
`;
